import * as React from 'react';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { useParams } from 'react-router';
import {
    makeStyles,
    Typography,
} from '@material-ui/core/';
import { Link } from 'react-router-dom';
import classnames from 'classnames';


import { TopActionBar, TaskName, VimoTaskContent } from '../../common/components';
import AboutTheExercises from './components/AboutTheExercises';

import urls from '../../app/urls';
import { isNullOrUndefined } from '../../youwell-common/stringUtils';
import RedirectIfNoLicense from '../../common/components/RedirectIfNoLicense';

const useStyles = makeStyles(theme => ({
    root: {

    },
    content: {
        padding: theme.spacing(4),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
    },
    tasksHeader: {
        marginTop: theme.spacing(4),
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
        background: theme.colors.grey2,
    },
    stepHeading: {
        minHeight: theme.spacing(3),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    steps: {
        display: 'flex',
        padding: theme.spacing(1),

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    step: {
        flex: '1 1 auto',
        padding: theme.spacing(1),
    },
    borderLeft: {
        borderLeft: theme.borders.normal,

        [theme.breakpoints.down('xs')]: {
            borderLeft: 0,
        },
    },
    skillDescription: {
        flex: '1 1 auto',
    },
    imageContainer: {
        width: `calc(50% - ${theme.spacing(1)}px)`,
        marginLeft: theme.spacing(1),

        [theme.breakpoints.down('xs')]: {
            width: `calc(100% - ${theme.spacing(4)}px)`,
            margin: theme.spacing(2),
        },
    },
    image: {
        width: '100%',
    },
    task: {
        padding: theme.spacing(0.5),
        borderRadius: theme.spacing(0.5),
        marginBottom: theme.spacing(2),

        '&:hover': {
            background: theme.colors.grey1,
        },
    },
    aboutTasks: {
        margin: theme.spacing(3),
        marginTop: theme.spacing(10),

        [theme.breakpoints.down('xs')]: {
            margin: 0,
            marginTop: theme.spacing(10),
        },
    },
    aboutTasksHeader: {
        margin: theme.spacing(1),
        marginBottom: theme.spacing(2),
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
        background: theme.colors.grey2,
    },
}));

const Skill = () => {
    const { skillId } = useParams();
    const skillData = useSelector(state => state.program.skillDetails && state.program.skillDetails[skillId]);
    const skillContentModule = useSelector(state => state.program.content
        && state.program.content[state.pageSettings.appConfig?.contentProgramId]?.modules
        ?.find(d => d.id === state.pageSettings.appConfig?.skillContentModuleId));
    const classes = useStyles();
    const translate = useSelector(state => getTranslate(state.localize));

    if (!skillData || !skillContentModule) {
        return null;
    }

    const skillDescription = skillContentModule.tasks?.find(d => d.name.toLowerCase().indexOf('intro tekst') > -1);

    const steps = skillData.tasks.reduce((prev, curr) => (
        {
            ...prev,
            [curr.label]: prev[curr.label] ? [...prev[curr.label], curr] : [curr],
        }
    ), {});

    const stepWidth = 100 / Object.entries(steps).length;

    return (
        <div className={classes.root}>
            <RedirectIfNoLicense />
            <TopActionBar
                title={skillData.name}
                backLink={{
                    to: urls.inside.program.home,
                    text: translate('program.backToProgram'),
                }}
            />

            <div className={classes.content}>
                {skillDescription && (
                    <VimoTaskContent task={skillDescription} className={classes.skillDescription} />
                )}

                <Typography variant="h6" className={classes.tasksHeader}>
                    {translate('program.availableTasks')}
                </Typography>

                <div className={classes.steps}>
                    {Object.entries(steps).map(([name, tasks], index) => (
                        <div key={name} className={classnames(classes.step, { [classes.borderLeft]: index > 0 })} style={{ flexBasis: `${stepWidth}%` }}>
                            <Typography variant="h6" className={classes.stepHeading}>
                                {isNullOrUndefined(name) ? '' : name}
                            </Typography>
                            {tasks && tasks.map(task => (
                                <Link to={`${urls.inside.program.skill}/${skillData.id}/${urls.inside.program.parts.task}/${task.id}`} key={task.id}>
                                    <TaskName task={task} className={classes.task} />
                                </Link>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            <div className={classes.aboutTasks}>
                <Typography variant="h6" className={classes.aboutTasksHeader}>
                    {translate('methodsAndTechniques.aboutTheExercisesHeading')}
                </Typography>

                <AboutTheExercises />
            </div>

        </div>
    );
};

export default Skill;
